// src/LandingPage.tsx
import { useState } from 'react';
import { useAuth } from './AuthContext';
import { AuthModal } from './AuthModal';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

export function LandingPage() {
  const { author } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="landing">
      <header className="landing-hero">
        <div className="hero-rings" aria-hidden="true">
          <span className="ring ring-a" />
          <span className="ring ring-b" />
        </div>
        <h1>Shelfkin</h1>
        <p className="landing-tagline">
          Finding kindred readers. Something new is on the way.
        </p>
        {author ? (
          <button className="landing-cta" onClick={() => navigate('/dashboard')}>
            Go to your dashboard
          </button>
        ) : (
          <button className="landing-cta" onClick={() => setShowModal(true)}>
            Sign in / Join Shelfkin
          </button>
        )}
      </header>

      <div className="dinkus" aria-hidden="true"><span /></div>

      <section className="landing-section">
        <h2>What is Shelfkin</h2>
        <p>
          Shelfkin is a platform to simplify the creation, uploading, and analysis of high quality Facebook Ad content for Amazon-focused authors.
          High performing ad styles changes over time and making them usually requires the use and learning of many tools.
          Shelfkin aims to make it easy for you to create these videos easily, while adhering to known good practices.
        </p>
      </section>

      <section className="landing-section">
        <h2>Why Shelfkin was created</h2>
        <p>Marketing takes a lot of time for an author. They have difficulty:</p>
        <ul className="landing-goals">
          <li>finding the time for marketing</li>
          <li>knowing which ad styles work best</li>
          <li>learning the various tools to make high quality ads</li>
          <li>attributing and analyzing ads to know what truly works</li>
          <li>Facebook setup for success</li>
        </ul>
        <p style={{ marginTop: '18px' }}>
          Today, Shelfkin will help you quickly writes effective ads using proven ad templates.
          Soon, it will also create your Amazon attributions and upload to Facebook.
        </p>
      </section>

      {showModal && <AuthModal onClose={() => setShowModal(false)} />}
    </div>
  );
}
